function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", event => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN"
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", event => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}
function pauseAllMedia(currentVideo = null, force = false) {
  document.querySelectorAll(".js-youtube").forEach(video => {
    if (video.closest("[data-pause-all-media-ignore]")) return;
    if (
      (video !== currentVideo && !video.closest("[data-autoload]")) ||
      (video !== currentVideo && force === true)
    ) {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
      video.setAttribute("play", "0");
    }
  });
  document.querySelectorAll(".js-vimeo").forEach(video => {
    if (video.closest("[data-pause-all-media-ignore]")) return;
    if (
      (video !== currentVideo && !video.closest("[data-autoload]")) ||
      (video !== currentVideo && force === true)
    ) {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
      video.setAttribute("play", "0");
    }
  });
  document.querySelectorAll("video").forEach(video => {
    if (video.closest("[data-pause-all-media-ignore]")) return;
    if (
      (video !== currentVideo && !video.closest("[data-autoload]")) ||
      (video !== currentVideo && force === true)
    ) {
      video.pause();
      video.setAttribute("play", "0");
    }
  });
  document.querySelectorAll("product-model").forEach(model => {
    if (model.closest("[data-pause-all-media-ignore]")) return;
    if (model.modelViewerUI && (!model.closest("[data-autoload]") || force))
      model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(button =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    /* currentTarget, not target: a tap lands on the icon <svg> inside the
       button, whose name is empty, so plus stepped down and minus at the
       minimum never removed the line. */
    const button = event.currentTarget;

    /* In the drawer the number holds until the response repaints the row, so
       it moves with the price rather than ahead of it. The step is taken and
       undone in the same task — the input never paints it — and the quantity
       asked for rides on the change event for cart.js to send. */
    if (this.closest("cart-drawer-items")) {
      let intended = 0;
      const atMin =
        button.name === "minus" &&
        parseInt(this.input.value) <= (parseInt(this.input.min) || 1);
      if (!atMin) {
        button.name === "plus" ? this.input.stepUp() : this.input.stepDown();
        intended = this.input.value;
        this.input.value = previousValue;
        if (intended === previousValue) return;
      }
      this.input.dispatchEvent(
        new CustomEvent("change", { bubbles: true, detail: { quantity: intended } })
      );
      return;
    }

    // If minus is clicked and quantity is at minimum (1), remove the item
    if (button.name === "minus") {
      const currentValue = parseInt(this.input.value);
      const minValue = parseInt(this.input.min) || 1;

      if (currentValue <= minValue) {
        // Set to 0 to trigger removal
        this.input.value = 0;
        this.input.dispatchEvent(this.changeEvent);
        return;
      }
    }

    button.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    // Don't disable minus button - it acts as remove when at min quantity
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`
    }
  };
}

/* Cart requests the theme makes on its own (free-gift lines, the add-on card's
   price lookup) are not shopper adds. Shopify's web pixels manager watches the
   page's fetch and XHR, and turns every /cart/add, /cart/change and /cart/update
   that adds a line into product_added_to_cart, which reaches Meta, GA and
   Shopify's analytics as an Add to Cart. The fetch of a hidden same-origin
   iframe is not watched, so these go through it. If the iframe can't be had,
   fall back to the page's fetch: counted twice, but never broken. */
let untrackedCartFrame = null;

window.untrackedCartFetch = (url, init) => {
  try {
    if (!untrackedCartFrame || !untrackedCartFrame.isConnected || !untrackedCartFrame.contentWindow) {
      const frame = document.createElement("iframe");
      frame.style.display = "none";
      frame.setAttribute("aria-hidden", "true");
      frame.tabIndex = -1;
      (document.body || document.documentElement).appendChild(frame);
      untrackedCartFrame = frame;
    }
    const frameWindow = untrackedCartFrame.contentWindow;
    return frameWindow.fetch.call(frameWindow, new URL(url, location.href).href, {
      credentials: "same-origin",
      ...init,
    });
  } catch (error) {
    return window.fetch(url, init);
  }
};

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  let formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    let parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach(summary =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      button =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach(details => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach(submenu => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    // Freeze the page and pin the header first, then measure where the header
    // ends, so the drawer starts right under it wherever the page was scrolled.
    // Pin the header where it sits on screen now (under the announcement bar
    // at the top of the page, at the very top once scrolled).
    document.documentElement.style.setProperty(
      "--menu-header-top",
      `${Math.max(0, this.header.getBoundingClientRect().top)}px`
    );
    lockPageScroll();
    this.header.classList.add("menu-open");
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    unlockPageScroll();
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

/* iOS Safari ignores overflow:hidden on <body> for touch scrolling, so with the
   mobile menu open the page kept scrolling underneath it (and Safari's toolbar
   moving on a tap scrolled it too). The header, and the drawer hanging from it,
   went up with the page and the page showed through. Freezing <body> in place
   with position:fixed is the lock iOS respects; the scroll position is put
   back when the menu closes. */
function lockPageScroll() {
  if (document.body.dataset.scrollLock) return;
  const y = window.scrollY || document.documentElement.scrollTop || 0;
  document.body.dataset.scrollLock = String(y);
  Object.assign(document.body.style, { position: "fixed", top: `-${y}px`, left: "0", right: "0", width: "100%" });
}

function unlockPageScroll() {
  const saved = document.body.dataset.scrollLock;
  if (saved === undefined) return;
  delete document.body.dataset.scrollLock;
  Object.assign(document.body.style, { position: "", top: "", left: "", right: "", width: "" });
  window.scrollTo(0, parseInt(saved, 10) || 0);
}

// Coming back to a page from the back/forward cache must not leave it frozen.
window.addEventListener("pageshow", (event) => {
  if (event.persisted) unlockPageScroll();
});

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", event => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", event => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", event => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

const DeviceObserver = (() => {

  const mql = window.matchMedia("(max-width: 749px)");
  let device = mql.matches ? "mobile" : "desktop";
  const subs = new Set();

  const notify = () => {
    device = mql.matches ? "mobile" : "desktop";
    subs.forEach(cb => { try { cb(device); } catch {} });
  };

  mql.addEventListener("change", notify);

  return {
    subscribe(cb) { subs.add(cb); cb(device); return () => subs.delete(cb); },
    device() { return device; }
  };
})();

// --- Global reload guard: ensures only ONE reload across all components ---
(() => {
  if (!window.__DeferredMediaReloadGuard) {
    window.__DeferredMediaReloadGuard = {
      _scheduled: false,
      scheduleOnce(delayMs = 60) {
        if (this._scheduled) return;
        this._scheduled = true;
        // (optional) mark in sessionStorage to help debug / avoid rare loops
        try { sessionStorage.setItem('__DM_lastReload', String(Date.now())); } catch {}
        setTimeout(() => { location.reload(); }, delayMs);
      }
    };
  }
})();

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.autoLoad = false;
    this.showControls = null;
    this.device = DeviceObserver.device();
    this._unsubDevice = null;

    this._originalAutoplay = null;   // 0 | 1 (read once from <template>)
    this._apEscalatedOnce = false;   // set true after desktop click escalation (when orig=0)
  }

  // ===== helpers =====
  isMobile() { return DeviceObserver.device() === 'mobile'; }

  _urlSetParams(url, kv) {
    try {
      const u = new URL(url, window.location.href);
      Object.entries(kv).forEach(([k, v]) => {
        if (v === null || typeof v === 'undefined') u.searchParams.delete(k);
        else u.searchParams.set(k, String(v));
      });
      return u.toString();
    } catch {
      return url;
    }
  }

  _readOriginalAutoplayFromTemplate() {
    if (this._originalAutoplay !== null) return this._originalAutoplay;

    try {
      const tpl = this.querySelector('template');
      if (!tpl || !tpl.content || !tpl.content.firstElementChild) return (this._originalAutoplay = 0);
      const probe = tpl.content.firstElementChild;

      if (probe.tagName === 'IFRAME') {
        const raw = probe.getAttribute('src');
        if (!raw) return (this._originalAutoplay = 0);
        const u = new URL(raw, window.location.href);
        const ap = (u.searchParams.get('autoplay') || '').toLowerCase();
        return (this._originalAutoplay = (ap === '1' || ap === 'true') ? 1 : 0);
      }

      if (probe.tagName === 'VIDEO') {
        // boolean attr: presence means true (even autoplay="")
        if (!probe.hasAttribute('autoplay')) return (this._originalAutoplay = 0);
        const val = (probe.getAttribute('autoplay') ?? '').toLowerCase();
        return (this._originalAutoplay = (val === '' || val === 'true' || val === '1') ? 1 : 0);
      }
    } catch {}
    return (this._originalAutoplay = 0);
  }

  _shouldShowControls() {
    const isMobile = this.isMobile();
    switch (this.showControls) {
      case 'all': return true;
      case 'mobile': return !!isMobile;
      case 'desktop': return !isMobile;
      default: return false;
    }
  }

  // === Controls-only sync (NEVER touches autoplay) ===
  _syncControlsOnlyTemplate(shouldShowControls) {
    try {
      const tpl = this.querySelector('template');
      if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
      const probe = tpl.content.firstElementChild;

      if (probe.tagName === 'IFRAME') {
        const raw = probe.getAttribute('src') || '';
        if (!raw) return;
        const next = this._urlSetParams(raw, { controls: shouldShowControls ? 1 : 0 });
        if (next !== raw) probe.setAttribute('src', next);

      } else if (probe.tagName === 'VIDEO') {
        if (shouldShowControls) probe.setAttribute('controls', 'true');
        else probe.removeAttribute('controls');
      }
    } catch (e) {
      console.warn('[DeferredMedia] _syncControlsOnlyTemplate error:', e);
    }
  }

  _syncControlsOnlyInserted(shouldShowControls) {
    const el = this.querySelector('video, model-viewer, iframe');
    if (!el) return;

    if (el.tagName === 'IFRAME') {
      const raw = el.getAttribute('src') || '';
      if (!raw) return;
      const next = this._urlSetParams(raw, { controls: shouldShowControls ? 1 : 0 });
      if (next !== raw) el.setAttribute('src', next);

    } else if (el.tagName === 'VIDEO') {
      if (shouldShowControls) el.setAttribute('controls', 'true');
      else el.removeAttribute('controls');
    }
  }

  // === Desktop-only one-time autoplay escalation (when original=0). Also sync controls. ===
  _desktopEscalateAutoplayOnceAndSyncControls() {
    if (this.isMobile()) return;                 // never escalate on mobile
    if (this._apEscalatedOnce) return;

    const orig = this._readOriginalAutoplayFromTemplate();
    if (orig === 1) { this._apEscalatedOnce = true; return; } // respect original 1 forever

    // 1) flip autoplay in <template>
    try {
      const tpl = this.querySelector('template');
      if (tpl && tpl.content && tpl.content.firstElementChild) {
        const probe = tpl.content.firstElementChild;
        if (probe.tagName === 'IFRAME') {
          const raw = probe.getAttribute('src') || '';
          if (raw) {
            const next = this._urlSetParams(raw, { autoplay: 1 });
            if (next !== raw) probe.setAttribute('src', next);
          }
        } else if (probe.tagName === 'VIDEO') {
          probe.setAttribute('autoplay', 'true'); // boolean attribute
        }
      }
    } catch (e) {
      console.warn('[DeferredMedia] escalate(template) error:', e);
    }

    // 2) flip autoplay in the already inserted element (if present)
    try {
      const el = this.querySelector('video, model-viewer, iframe');
      if (el) {
        if (el.tagName === 'IFRAME') {
          const raw = el.getAttribute('src') || '';
          if (raw) {
            const next = this._urlSetParams(raw, { autoplay: 1 });
            if (next !== raw) el.setAttribute('src', next);
          }
        } else if (el.tagName === 'VIDEO') {
          el.setAttribute('autoplay', 'true');
        }
      }
    } catch (e) {
      console.warn('[DeferredMedia] escalate(inserted) error:', e);
    }

    // 3) always sync controls to current device policy (controls may depend on data-show-controls)
    const show = this._shouldShowControls();
    this._syncControlsOnlyTemplate(show);
    this._syncControlsOnlyInserted(show);
    this.setAttribute('data-controls-showed', show ? 'true' : 'false');

    this._apEscalatedOnce = true;
  }

  // ===== lifecycle =====
  connectedCallback() {
    this.autoLoad = this.hasAttribute('data-autoload');
    this.showControls = this.getAttribute('data-show-controls');
    this.device = DeviceObserver.device();

    // On load: NEVER touch autoplay.
    // But we do keep controls in sync (template + inserted when contentLoaded).
    const initShow = this._shouldShowControls();
    this._syncControlsOnlyTemplate(initShow);
    this.setAttribute('data-controls-showed', initShow ? 'true' : 'false');

    this.addEventListener('contentLoaded', () => {
      const show = this._shouldShowControls();
      this._syncControlsOnlyInserted(show);
      this.setAttribute('data-controls-showed', show ? 'true' : 'false');
    });

    // Optional guarded reload on device switch (your existing global guard)
    this._unsubDevice = DeviceObserver.subscribe((newDevice) => {
      if (newDevice !== this.device) {
        this.device = newDevice;
        //window.__DeferredMediaReloadGuard?.scheduleOnce?.();
      }
    });

    // Keep your autoload behavior (does not apply autoplay policy)
    const isControlsMobile = this.isMobile() && ['all', 'mobile'].includes(this.showControls);
    if (this.autoLoad && this.hasAttribute('data-autoload-in-view') && 'IntersectionObserver' in window) {
      this._autoloadWhenInView();
    } else if (this.autoLoad || isControlsMobile) {
      this.loadContent();
    }

    // CLICK: on desktop, if original autoplay=0, flip to 1 (once) and sync controls; then toggle/play.
    this.addEventListener('click', () => {
      this._desktopEscalateAutoplayOnceAndSyncControls();
      this.loadContent();
    });
  }

  disconnectedCallback() {
    if (this._unsubDevice) {
      try { this._unsubDevice(); } catch {}
      this._unsubDevice = null;
    }
    if (this._inViewObserver) {
      this._inViewObserver.disconnect();
      this._inViewObserver = null;
    }
  }

  // Gallery slides autoload only once they are the slide on screen. Slides
  // Swiper has moved aside are clipped by its overflow, and the CSS-hidden copy
  // of the gallery has no box, so neither intersects until it is shown. Half
  // the media visible means the shopper landed on it, not that a drag is
  // peeking past it.
  _autoloadWhenInView() {
    this._inViewObserver = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)) return;
      this._inViewObserver.disconnect();
      this._inViewObserver = null;
      if (this.getAttribute('loaded')) return;
      // On connect, the pauseAllMedia in loadContent had nothing to pause yet.
      // Arriving later, it would stop a video the shopper started themselves.
      this._autoloading = true;
      try { this.loadContent(false); } finally { this._autoloading = false; }
    }, { threshold: 0.5 });
    this._inViewObserver.observe(this);
  }

  // Exposed controls toggler (keeps controls only; never touches autoplay)
  setControlsStatus() {
    const show = this._shouldShowControls();
    this._syncControlsOnlyTemplate(show);
    this._syncControlsOnlyInserted(show);
    this.setAttribute('data-controls-showed', show ? 'true' : 'false');
    return show;
  }

  updateUrlParameter(url, param, value) {
    return this._urlSetParams(url, { [param]: value });
  }

  controlsState(state) {
    const el = this.querySelector('video, model-viewer, iframe');
    if (!el) return;
    if (el.nodeName === 'VIDEO') {
      if (state) el.setAttribute('controls', 'true'); else el.removeAttribute('controls');
    } else if (el.nodeName === 'IFRAME') {
      const raw = el.getAttribute('src') || '';
      if (!raw) return;
      const next = this._urlSetParams(raw, { controls: state ? 1 : 0 });
      if (next !== raw) el.setAttribute('src', next);
    }
    this.setAttribute('data-controls-showed', state ? 'true' : 'false');
  }

  // === load/toggle logic (kept close to your "mobile-perfect" version) ===
  loadContent(focus = true, force = false) {
    if (!this.getAttribute('loaded')) {
      if (!this._autoloading) window.pauseAllMedia?.();

      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );
      this.setAttribute('loaded', 'true');

      const el = this.insertBefore(
        content.querySelector('video, model-viewer, iframe'),
        this.firstChild
      );

      this.dispatchEvent(new CustomEvent('contentLoaded'));

      el.setAttribute('play', '1');

      // Respect original autoplay: if <video> has autoplay (original or escalated), ensure playback starts
      if (el.nodeName === 'VIDEO' && el.hasAttribute('autoplay')) {
        el.play?.();
      }

    } else {
      const el = this.querySelector('video, model-viewer, iframe');
      if (!el) return;

      if (el.nodeName === 'VIDEO') {
        if ((el.paused && el.getAttribute('play') === '0') || el.ended || force === true) {
          el.play?.();
          el.setAttribute('play', '1');
        } else {
          el.pause?.();
          el.setAttribute('play', '0');
        }
        window.pauseAllMedia?.(el);

      } else if (el.nodeName === 'IFRAME') {
        let play = el.hasAttribute('play') ? parseInt(el.getAttribute('play')) : 0;
        const command = play ? 'pause' : 'play';

        if (el.classList.contains('js-youtube')) {
          el.contentWindow?.postMessage(`{"event":"command","func":"${command}Video","args":""}`, '*');
          el.setAttribute('play', command === 'play' ? '1' : '0');
        } else if (el.classList.contains('js-vimeo')) {
          el.contentWindow?.postMessage(`{"method":"${command}"}`, '*');
          el.setAttribute('play', command === 'play' ? '1' : '0');
        }

        window.pauseAllMedia?.(el);
      }
    }
  }
}

if (!customElements.get('deferred-media')) {
  customElements.define('deferred-media', DeferredMedia);
}

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.dotsCounter = this.querySelector(".slider-counter.dots");
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      element => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.dotsCounter) {
      if (this.currentPage != previousPage) {
        this.dotsCounter.querySelector(".active")?.classList.remove("active");
        this.dotsCounter
          .querySelector(`[data-index="${this.currentPage}"]`)
          ?.classList.add("active");
      }
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach(link =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach(button => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");
    this.nextButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach(button => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach(button => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const direction = button === "previous" ? "previous" : "next";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      select => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach(mediaGallery =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      variant => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option')
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          variant =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then(response => response.text())
      .then(responseText => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "visibility-hidden",
            pricePerItemSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant
          }
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
    if (pricePerItem) pricePerItem.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        radio => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch(e => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px"
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class TimerComponent extends HTMLElement {
  constructor() {
    super();
    this.limit = this.getAttribute("data-timer-minutes");

    if (!this.limit) {
      this.limit = "30";
    }
    this.limit = this.limit * 60 * 1000;
  }

  connectedCallback() {
    const getFinish = () => {
      let finish = sessionStorage.getItem(this.id + "-finish");

      if (!finish || new Date().getTime() > new Date(finish * 1).getTime()) {
        finish = new Date(new Date().getTime() + this.limit).getTime();
        sessionStorage.setItem(this.id + "-finish", finish.toString());
        return finish;
      }

      return finish * 1;
    };

    const difference2Parts = milliseconds => {
      const sec_s = Math.floor(Math.abs(milliseconds) / 1000);
      const min_s = Math.floor(sec_s / 60);
      const hours = Math.floor(min_s / 60);

      return {
        hours: hours % 24,
        minutes: min_s % 60,
        seconds: sec_s % 60
      };
    };

    const showDiff = diff => {
      this.querySelector("[data-hours]").innerText =
        diff.hours > 9 ? diff.hours : "0" + diff.hours;
      this.querySelector("[data-minutes]").innerText =
        diff.minutes > 9 ? diff.minutes : "0" + diff.minutes;
      this.querySelector("[data-seconds]").innerText =
        diff.seconds > 9 ? diff.seconds : "0" + diff.seconds;
    };

    const _finish = getFinish();

    showDiff(difference2Parts(new Date(_finish) - new Date()));

    setInterval(() => {
      showDiff(difference2Parts(new Date(_finish) - new Date()));
    }, 1000);
  }

  disconnectedCallback() {
    sessionStorage.removeItem(this.id + "-finish");
  }
}

if (!customElements.get("timer-component")) {
  customElements.define("timer-component", TimerComponent);
}

class CartUpsellProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.form.querySelector("[name=id]").disabled = false;
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.submitButton = this.querySelector('[type="submit"]');

    if (document.querySelector("cart-drawer"))
      this.submitButton.setAttribute("aria-haspopup", "dialog");

    this.hideErrors = this.dataset.hideErrors === "true";
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");
    this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

    const drawerOverlay = document.getElementById('CartDrawer-LoadingOverlay');
    if (drawerOverlay) drawerOverlay.classList.remove('hidden');

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map(section => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: response.errors || response.description,
            message: response.message
          });
          console.error(response.description);

          const soldOutMessage =
            this.submitButton.querySelector(".sold-out-message");
          if (!soldOutMessage) return;
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
            cartData: response
          });
        this.error = false;
        // The line this adds fades into the drawer. See planRowMotion in cart.js.
        window.cartUpsellEnterAt = Date.now();
        this.cart.renderContents(response);
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
        const drawerOverlay = document.getElementById('CartDrawer-LoadingOverlay');
        if (drawerOverlay) drawerOverlay.classList.add('hidden');
      });
  }
}

if (!customElements.get("cart-upsell-product-form")) {
  customElements.define("cart-upsell-product-form", CartUpsellProductForm);
}

(function () {
  const getNodes = (expr, parent) => {
    let results = [];
    let contextNode = parent || document;
    /* Evaluate from the node's own document. The cart drawer runs this over
       markup it parsed with DOMParser, and Firefox throws ("Node cannot be
       used in a document other than the one in which it was created") when
       the page's document evaluates a node of another one. Chrome and Safari
       let it pass, so add to cart failed in Firefox only. */
    let query = (contextNode.ownerDocument || contextNode).evaluate(
      expr,
      contextNode,
      null,
      XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
      null
    );

    for (let i = 0, length = query.snapshotLength; i < length; ++i) {
      results.push(query.snapshotItem(i));
    }
    return results;
  };

  const transformText = (targetElement = document.body) => {

    if (/^\/pages\/(lp-|lp_|listicle|story|airlock-story)/.test(window.location.pathname)) return;
    
    const expr =
      '//*[not(self::script or self::noscript or self::title)]/text()[' +
      'contains(., "AIRLOCK One") or ' +
      'contains(., "AIRLOCK Voyage") or ' +
      'contains(., "AIRLOCK MoistureGuard") or ' +
      'contains(., "AIRLOCK OdorGuard") or ' +
      'contains(., "AIRLOCK ONE") or ' +
      'contains(., "AIRLOCK VOYAGE")]';

    const textNodes = getNodes(expr, targetElement);

    textNodes.forEach(textNode => {
      const parent = textNode.parentNode;

      let current = parent;
      while (current && current !== document.body) {
        if (current.hasAttribute?.('disable-transform')) return;
        current = current.parentNode;
      }

      const src = textNode.textContent;

      if (!/(AIRLOCK (One|ONE|Voyage|VOYAGE|MoistureGuard|OdorGuard))/.test(src)) return;

      const replaced = src
      .replace(/AIRLOCK One/g,     'AIRLOCK <span class="product-name-badge product-name-badge--after-brand">One</span>')
      .replace(/AIRLOCK ONE/g,     'AIRLOCK <span class="product-name-badge product-name-badge--after-brand">ONE</span>')
      .replace(/AIRLOCK Voyage/g,  'AIRLOCK <span class="product-name-badge product-name-badge--after-brand">Voyage</span>')
      .replace(/AIRLOCK VOYAGE/g,  'AIRLOCK <span class="product-name-badge product-name-badge--after-brand">VOYAGE</span>')
      .replace(/AIRLOCK MoistureGuard/g, 'AIRLOCK <span class="product-name-badge product-name-badge--after-brand">MoistureGuard</span>')
      .replace(/AIRLOCK OdorGuard/g,     'AIRLOCK <span class="product-name-badge product-name-badge--after-brand">OdorGuard</span>');

      if (replaced === src) return;

      const wrapper = document.createElement('span');
      wrapper.innerHTML = replaced;

      const frag = document.createDocumentFragment();
      while (wrapper.firstChild) frag.appendChild(wrapper.firstChild);

      parent.replaceChild(frag, textNode);
    });

  };

  document.addEventListener("textTransform", event => {
    const target = event.detail;
    if (target instanceof HTMLElement) {
      transformText(target);
    }
  });

  window.addEventListener("DOMContentLoaded", () => {
    transformText();
  });

  window.transformText = transformText;

  window.triggerTextTransform = element => {
    document.dispatchEvent(
      new CustomEvent("textTransform", { detail: element })
    );
  };
})();

function goToElement(force, animation = "smooth") {
  const hash = !force
    ? window.location.hash.replace("#", "")
    : force.replace("#", "");
  if (hash) {
    let targetElement = document.querySelector("[data-id=" + hash + "]");
    if (!targetElement) {
      targetElement = document.querySelector("#" + hash);
    }
    if (targetElement) {
      const header = document.querySelector("sticky-header");
      let offset = 0;
      if (header) {
        offset = header.clientHeight;
      }
      const top =
        targetElement.getBoundingClientRect().top - offset + window.pageYOffset;
      window.scrollTo({ top: top, behavior: animation });
    }
  }
}
function validateOpenerHashes(hash = null) {
  if (!hash) {
    hash = window.location.hash;
  }
  return (
    window?.menuOpenerHashes &&
    window?.menuOpenerHashes.length &&
    window?.menuOpenerHashes.includes(hash)
  );
}

window.addEventListener("hashchange", () => {
  //goToElement();
});
window.addEventListener("load", () => {
  setTimeout(() => {
    goToElement();
  }, 500);
});
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('a[href*="#"]').forEach(item => {
    item.addEventListener("click", e => {
      const link = e.target.closest("a");
      const url = new URL(link.href);
      if (
        link &&
        !link.hasAttribute("data-scroll-to-disabled") &&
        !validateOpenerHashes(url.hash)
      ) {
        e.preventDefault();
        goToElement(url.hash, "smooth");
      }
    });
  });
});

(function () {
  function hashMainMenuOpener() {
    let header, element;
    if (window.innerWidth > 989) {
      header = document.querySelector("header-menu");
    } else {
      header = document.querySelector("header-drawer");
    }
    if (header) {
      element = header.querySelector("summary");
      if (element && element.getAttribute("aria-expanded") === "false") {
        element = header.querySelector("summary");
        element.click();
        element.focus();
      }
    }
    clearHash();
  }

  function clearHash() {
    history.replaceState(
      null,
      document.title,
      window.location.pathname + window.location.search
    );
  }

  function menuOpenerHandleHashChange() {
    if (validateOpenerHashes()) {
      hashMainMenuOpener();
    }
  }

  window.addEventListener("hashchange", menuOpenerHandleHashChange);
  document.addEventListener("DOMContentLoaded", () => {
    if (validateOpenerHashes()) {
      hashMainMenuOpener();
    }
  });
})();
